import {CreatePopupRestDto} from "@/api/pharma-cms-popup/models";

export class CreatePopupRestDtoModel implements CreatePopupRestDto {
    name: string;

    constructor(name: string) {
        this.name = name;
    }

    public static createWithDefaults(): CreatePopupRestDtoModel {
        return new this('');
    }
}
